export * from './ubiLayoutDetail.component';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiLayoutDetail/index.ts